import './CampaignBlockList.scss';
import React from 'react';
import CampaignBlock from './CampaignBlock';
import classNames from 'classnames';
function CampaignBlockList({ blocks }) {
    if (!blocks || blocks.length < 1)
        return null;
    const classes = classNames('campaign-block-list', `campaign-block-list--blocks-${blocks.length}`);
    return (React.createElement("div", { className: classes }, blocks.map((b, i) => {
        return React.createElement(CampaignBlock, { key: i, image: b.image, text: b.text });
    })));
}
export default CampaignBlockList;
